import React from 'react';
import classNameBind from 'classnames/bind';
import { FieldArray, Formik } from 'formik';
import FormContext from '../../utils/hoc/formHelpers/context';
import Cancel from './components/Cancel';
import Submit from './components/Submit';
import styles from './Form.module.css';

const bindClasses = classNameBind.bind(styles);

const InnerForm = ({
  children,
  render,
  id,
  api,
  dataId,
  fullHeight,
}) => (
  <FormContext.Provider value={{ ...api, id }}>
    <form id={id} className={bindClasses({ fullHeight })} onSubmit={api.handleSubmit} noValidate data-ppuc-id={dataId}>
      {children || render(api)}
    </form>
  </FormContext.Provider>
);

export default class Form extends React.Component {
  static defaultProps = {
    dataId: 'Form',
    fullHeight: false,
    formikRef: undefined,
    isInitialValid: false,
    validateOnBlur: true,
    validateOnChange: true,
  }

  static FieldArray = FieldArray;

  static Submit = Submit;

  static Cancel = Cancel;

  static InnerForm = InnerForm;

  render() {
    return (
      <Formik
        enableReinitialize
        initialValues={this.props.initialValues}
        validationSchema={this.props.validationSchema}
        validateOnBlur={this.props.validateOnBlur}
        validateOnChange={this.props.validateOnChange}
        onSubmit={this.props.onSubmit}
        ref={this.props.formikRef}
        isInitialValid={this.props.isInitialValid}
        render={api => (
          <InnerForm {...{ ...this.props, api }} />
        )}
      />
    );
  }
}
